import { render, staticRenderFns } from "./UserActionInfoAddPending.vue?vue&type=template&id=2bfde924&"
import script from "./UserActionInfoAddPending.vue?vue&type=script&lang=js&"
export * from "./UserActionInfoAddPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports